import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import * as $ from "jquery";

@Component({
	selector: 'app-addr',
	templateUrl: './addr.component.html',
	styleUrls: ['./addr.component.css']
})
export class AddrComponent implements OnInit {

	frm : FormGroup;

	logi_user:any;

	addrList:any = "";
	skeyword:any;

	passData:any = [];

	total_cnt:any = 0;

	@ViewChild('search') search;

	constructor(
		private http: HttpClient,
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public getData,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = new FormGroup({
			search: new FormControl('', Validators.required),
		});
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
	}

	searchAddr() {
		if( this.frm.get('search').value.length >= 2 )
		{
			setTimeout(() => {
				this.http.get(this.env.API_URL + 'api/address.php?keyword='+this.frm.get('search').value).subscribe((response) => {
					this.addrList = response['addrList'];
				});
			}, 500);
		}
	}

	selAddr(addr, addr2, sido, gugun, dong, x, y, road){
		this.passData['addr'] = addr2;
		this.passData['sido'] = sido;
		this.passData['gugun'] = gugun;
		this.passData['dong'] = dong;
		this.passData['x'] = x;
		this.passData['y'] = y;
		this.passData['road'] = road;

		this.dialogRef.close({
			event: 'close',
			data: this.passData
		});
	}

	async closeWrite() {
		this.dialogRef.close();
	}
}
